import { useEffect, useState } from "react";

export type ThemeMode = "light" | "dark";

const STORAGE_KEY = "gas-theme-mode";

function readStoredMode(): ThemeMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

function applyMode(mode: ThemeMode) {
  document.documentElement.classList.toggle("dark", mode === "dark");
  document.documentElement.setAttribute("data-theme-mode", mode);
}

/** Per-viewer light/dark preference, stored in localStorage purely as a UI convenience. */
export function useThemeMode() {
  const [mode, setModeState] = useState<ThemeMode>(readStoredMode);

  useEffect(() => {
    applyMode(mode);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // Ignore — theme still applies for this page load, just won't persist.
    }
  }, [mode]);

  function toggle() {
    setModeState((current) => (current === "dark" ? "light" : "dark"));
  }

  return { mode, setMode: setModeState, toggle };
}
